// src/pages/logias/OtrosAltares.jsx

const altaresNacionales = [
  { 
    id: "01", 
    nombre: "Capítulo de la Orden DeMolay Primax N°1", 
    sede: "Perú", 
    web: "#" 
  },
  { 
    id: "02", 
    nombre: "Supremo Consejo del Grado 33 del Rito Escocés Antiguo y Aceptado para la República del Perú", 
    sede: "Perú", 
    web: "#" 
  },
  { 
    id: "03", 
    nombre: "Capítulo de Masones del Real Arco del Perú", 
    sede: "Jurisdicción de EE.UU.", 
    web: "#" 
  },
  { 
    id: "04", 
    nombre: "Concilio de Masones Crípticos del Perú", 
    sede: "Jurisdicción de EE.UU.", 
    web: "#" 
  },
  { 
    id: "05", 
    nombre: "San Albano Nº 796, Soberano Capítulo del Real Arco de Escocia", 
    sede: "Perú", 
    web: "#" 
  }
];

const altaresInternacionales = [
  { 
    id: "01", 
    nombre: "Orden DeMolay Internacional", 
    pais: "EE.UU.", 
    web: "#" 
  },
  { 
    id: "02", 
    nombre: "Supremo Consejo del Grado 33 y último del R.·.E.·.A.·. y A.·. para España", 
    pais: "España", 
    web: "#" 
  },
  { 
    id: "03", 
    nombre: "Supremo Consejo del Grado 33 para la República de Argentina", 
    pais: "Argentina", 
    web: "#" 
  },
  { 
    id: "04", 
    nombre: "Supreme Grand Royal Arch Chapter of Scotland", 
    pais: "Escocia", 
    web: "#" 
  },
  { 
    id: "05", 
    nombre: "General Grand Chapter Royal Arch Masons INTERNATIONAL", 
    pais: "EE.UU.", 
    web: "#" 
  }
];

const OtrosAltares = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1558025137-0b406e9cb1ad?q=80&w=2000&auto=format&fit=crop')" }} // Imagen arquitectónica solemne
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Jurisdicciones y Fraternidad
          </p>
          <h1 className="font-serif text-4xl md:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-6">
            Otros Altares
          </h1>
          <p className="text-gray-400 font-light text-sm md:text-base max-w-2xl mx-auto animate-fade-in [animation-delay:0.6s]">
            Capítulos y Altares Filosóficos Nacionales e Internacionales con Reconocimiento Oficial.
          </p>
        </div>
      </section>

      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24 flex-grow w-full">
        
        {/* BLOQUE 1: Altares Nacionales */}
        <div className="mb-24">
          <div className="flex items-center gap-4 mb-12">
            <h2 className="font-serif text-3xl md:text-4xl text-white">Altares <span className="text-[#C5A059] italic font-light">Nacionales</span></h2>
            <div className="h-[1px] flex-grow bg-gradient-to-r from-[#C5A059]/50 to-transparent ml-4"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {altaresNacionales.map((altar, idx) => (
              <div key={idx} className="group bg-[#0a0a0a] border border-white/5 p-6 md:p-8 hover:border-[#C5A059]/40 transition-all duration-500 flex flex-col justify-between">
                <div>
                  <div className="flex justify-between items-start mb-4">
                    <span className="text-[#C5A059] font-serif text-2xl opacity-50">{altar.id}</span>
                    <span className="text-gray-500 text-[10px] tracking-widest uppercase border border-gray-700 px-2 py-1 bg-[#050505]">
                      {altar.sede}
                    </span>
                  </div>
                  <h3 className="font-serif text-xl md:text-2xl text-gray-200 group-hover:text-white transition-colors leading-relaxed mb-6">
                    {altar.nombre}
                  </h3>
                </div>
                
                <div className="mt-4 pt-4 border-t border-white/5 flex justify-end">
                  <a href={altar.web} className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-[#C5A059] hover:text-white transition-colors group/btn">
                    Visitar Portal
                    <svg className="w-4 h-4 transform group-hover/btn:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* BLOQUE 2: Altares Internacionales */}
        <div>
          <div className="flex items-center gap-4 mb-12">
            <h2 className="font-serif text-3xl md:text-4xl text-white">Reconocimiento <span className="text-[#C5A059] italic font-light">Internacional</span></h2>
            <div className="h-[1px] flex-grow bg-gradient-to-r from-[#C5A059]/50 to-transparent ml-4"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {altaresInternacionales.map((altar, idx) => (
              <div key={idx} className="group bg-[#050505] border border-white/5 p-6 md:p-8 hover:bg-[#0a0a0a] transition-all duration-500 flex flex-col justify-between">
                <div>
                  <div className="flex justify-between items-start mb-4">
                    <span className="text-gray-600 font-serif text-2xl">{altar.id}</span>
                    <span className="text-[#C5A059] text-[10px] tracking-widest uppercase border border-[#C5A059]/30 px-2 py-1 bg-[#C5A059]/5">
                      {altar.pais}
                    </span>
                  </div>
                  <h3 className="font-serif text-xl md:text-2xl text-gray-300 group-hover:text-white transition-colors leading-relaxed mb-6">
                    {altar.nombre}
                  </h3>
                </div>
                
                <div className="mt-4 pt-4 border-t border-white/5 flex justify-end">
                  <a href={altar.web} className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-gray-500 hover:text-[#C5A059] transition-colors group/btn">
                    Visitar Portal
                    <svg className="w-4 h-4 transform group-hover/btn:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

      </section>

    </div>
  );
};

export default OtrosAltares;